module.exports = __webpack_public_path__ + "img/logo-revisa.db12037e.svg";